module.exports = __webpack_public_path__ + "img/doorsext.5e540ad6.png";